import { ChevronDownIcon } from "@chakra-ui/icons";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";

const KYDMenuButton = ({
  options,
  title,
  isLoading,
}: {
  options: { label: string; onClick: () => void }[];
  title: string;
  isLoading?: boolean;
}) => (
  <Menu isLazy placement="bottom">
    <MenuButton
      as={Button}
      rightIcon={<ChevronDownIcon />}
      borderRadius="full"
      bg="black"
      textColor="white"
      _hover={{ bg: "gray.800" }}
      fontSize="16px"
      isLoading={isLoading}
    >
      {title}
    </MenuButton>

    <MenuList zIndex={10}>
      {options.map((option) => (
        <MenuItem key={option.label} onClick={option.onClick}>
          {option.label}
        </MenuItem>
      ))}
    </MenuList>
  </Menu>
);

export default KYDMenuButton;
